import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLElement> {
  static values = {
    fetchErrorHtml: String
  }

  declare readonly fetchErrorHtmlValue: string
  declare readonly hasFetchErrorHtmlValue: boolean

  connect(): void {
    this.element.addEventListener('turbo:before-fetch-response', event => {
      const { fetchResponse } = (event as CustomEvent).detail

      if (this.hasFetchErrorHtmlValue && !fetchResponse.response.ok) {
        this.element.innerHTML = this.fetchErrorHtmlValue
      }
    })
  }
}
